import { LitEntity, html } from '../utility/lit-entity';
import { StoreMixin } from '../utility/store-mixin';
import { IndexMixin } from '../utility/index-mixin';
import './work-order-grid-view';
import './work-order-show-view';
import './parts/work-order-bin-confirm';

class WorkOrderIndex extends IndexMixin(StoreMixin(LitEntity)) {
  static get properties() {
    return {
      selectedWorkOrderHref: { type: String, attribute: false },
    };
  }

  getViews() {
    return [
      {
        default: true,
        name: 'list',
        render: () => {
          return html`
            <work-order-grid-view .href="${this.href}" .path="${this.tail}"></work-order-grid-view>
          `;
        },
      },
      {
        name: 'show',
        render: () => {
          return html`
            <work-order-show-view .href="${this.selectedWorkOrderHref}"></work-order-show-view>
          `;
        },
      },
      {
        name: 'confirm',
        render: () => {
          return html`
            <work-order-bin-confirm .href="${this.selectedWorkOrderHref}"></work-order-bin-confirm>
          `;
        },
      },
    ];
  }

  _stateChanged({ query }) {
    this.selectedWorkOrderHref = (query || {}).workOrderId;
  }
}

window.customElements.define('work-order-index', WorkOrderIndex);
